/**
 * 数字保留位数
 * s : 数字/字符串
 * n : 保留位数
 */
import { isNumber } from '@/utils/lodash';

export default function formatNumber(val, n = 2) {
    if (isNumber(+val) && !Number.isNaN(+val)) {
        return (+val).toFixed(n);
    }

    return val;
}
